// Utility to append or merge the current 'market' query param to a given URL
// Usage: withMarketQuery('/some/path') => '/some/path?market=it' (if ?market=it in current URL)

export function withMarketQuery(href: string): string {
  if (typeof window === 'undefined') return href;

  const url = new URL(href, window.location.origin);
  const currentParams = new URLSearchParams(window.location.search);
  const market = currentParams.get('market');
  if (market) {
    url.searchParams.set('market', market);
  } else {
    url.searchParams.delete('market');
  }
  // For relative URLs, remove the origin
  return url.pathname + (url.search ? url.search : '');
}
